import React from 'react';

class Omnivirt extends React.Component {
  componentDidMount() {
    var id = this.props.mediaURL;
    if (this.vr360Container) {
      this.vr360Container.setAttribute(
        'src',
        '//upload.omnivirt.com/content/' +
          id +
          '?player=true&autoplay=true&referer=' +
          encodeURIComponent(window.location.href)
      );
      const script = document.createElement('script');
      script.src = '//cdn.omnivirt.com/scripts/embed.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  render() {
    return (
      <React.Fragment>
        <iframe
          ref={x => (this.vr360Container = x)}
          src='about:blank'
          height='100%'
          frameBorder='0'
          mozallowfullscreen='1'
          allowFullScreen='1'
          title='thai'
        />
      </React.Fragment>
    );
  }
}
export default Omnivirt;
